/**
 * Color Picker - Handles color variant selection and product updates
 * Updates the current page content when a color swatch is clicked
 */

class ColorPicker {
  constructor() {
    this.init();
  }

  init() {
    // Find all color picker inputs
    const colorInputs = document.querySelectorAll('.color-swatch-input');

    colorInputs.forEach(input => {
      input.addEventListener('change', (e) => this.handleColorChange(e));
    });

    // Add hover functionality to color swatches
    this.initHoverEffect();
  }

  initHoverEffect() {
    const colorLabels = document.querySelectorAll('.color-swatch-label');
    const colorNameSpan = document.querySelector('.color-picker-selected-name');

    if (!colorNameSpan) return;

    const selectedColorName = colorNameSpan.dataset.selectedColor;

    colorLabels.forEach(label => {
      label.addEventListener('mouseenter', () => {
        const hoverColorName = label.dataset.colorName;
        if (hoverColorName) {
          colorNameSpan.textContent = hoverColorName;
        }
      });

      label.addEventListener('mouseleave', () => {
        colorNameSpan.textContent = selectedColorName;
      });
    });
  }

  async handleColorChange(event) {
    const input = event.target;
    const productUrl = input.dataset.productUrl;
    const productHandle = input.dataset.productHandle;

    if (!productUrl || !productHandle) {
      console.error('Missing product URL or handle');
      return;
    }

    // Show loading state
    this.showLoading();

    try {
      // Fetch the new product page section
      const sectionId = this.getSectionId();
      const response = await fetch(`${productUrl}?section_id=${sectionId}`);

      if (!response.ok) {
        throw new Error('Failed to fetch product data');
      }

      const html = await response.text();

      // Update the page content
      this.updatePageContent(html, productUrl);

      // Update browser history
      window.history.pushState({ productHandle }, '', productUrl);

    } catch (error) {
      console.error('Error updating product:', error);
      this.showError();
    } finally {
      this.hideLoading();
    }
  }

  updatePageContent(html, newUrl) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Get the main product section
    const sectionId = this.getSectionId();
    const newSection = doc.querySelector(`#shopify-section-${sectionId}`);
    const currentSection = document.querySelector(`#shopify-section-${sectionId}`);

    if (newSection && currentSection) {
      // Replace the entire section to update all content
      currentSection.innerHTML = newSection.innerHTML;

      // Re-initialize the color picker for the new content
      this.init();

      // Re-initialize variant selects if they exist
      if (window.VariantSelects) {
        const variantSelects = currentSection.querySelector('variant-selects');
        if (variantSelects && variantSelects.onVariantChange) {
          // Trigger any variant select initialization
          const event = new Event('DOMContentLoaded');
          document.dispatchEvent(event);
        }
      }

      // Scroll to top of product section
      currentSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  getSectionId() {
    // Find the section ID from the current page
    const section = document.querySelector('[id^="shopify-section-template"]');
    if (section) {
      return section.id.replace('shopify-section-', '');
    }

    // Fallback: try to find from color picker element
    const colorPicker = document.querySelector('.cc-color-picker');
    if (colorPicker) {
      const sectionContainer = colorPicker.closest('[id^="shopify-section-"]');
      if (sectionContainer) {
        return sectionContainer.id.replace('shopify-section-', '');
      }
    }

    return 'template--main';
  }

  showLoading() {
    const colorPicker = document.querySelector('.cc-color-picker');
    if (colorPicker) {
      colorPicker.style.opacity = '0.5';
      colorPicker.style.pointerEvents = 'none';
    }

    // Add loading class to main product
    const mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (mainProduct) {
      mainProduct.classList.add('loading');
      mainProduct.style.opacity = '0.6';
    }
  }

  hideLoading() {
    const colorPicker = document.querySelector('.cc-color-picker');
    if (colorPicker) {
      colorPicker.style.opacity = '1';
      colorPicker.style.pointerEvents = 'auto';
    }

    // Remove loading class from main product
    const mainProduct = document.querySelector('[id^="MainProduct-"]');
    if (mainProduct) {
      mainProduct.classList.remove('loading');
      mainProduct.style.opacity = '1';
    }
  }

  showError() {
    // Simple error notification
    alert('Unable to load product. Please try again.');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ColorPicker();
  });
} else {
  new ColorPicker();
}

// Handle browser back/forward buttons
window.addEventListener('popstate', (event) => {
  if (event.state && event.state.productHandle) {
    // Reload the page when navigating with browser buttons
    window.location.reload();
  }
});
